export default "__VITE_ASSET__BlseugGa__"